/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal } from 'antd';
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Styles } from './style';
import { useAdminUsers } from "./hook";
import Active from "./sections/Active";
import Blocked from "./sections/Blocked";
import Merger from "./components/Merger";
import Requests from "./sections/Requests";
import { useCountry } from "../../../helpers/map";
import { TABS, mapOrganisation, tabs } from "./config";
import { actions } from "../../../store/reducers/admin";
import PermissionsModal from "./components/PermissionsModal";
import { AdminService, AuthenticationService } from "../../../services";
import SubjectTableLayout from "../../../components/Layout/SubjectTableLayout";
import { Header, ModalHeader, TabsHeader } from "datastake-daf/dist/components";
import { renderBreadCrumbs } from "../../../helpers/breadCrumbs";
import { useNavigate } from "react-router-dom";
import ReviewModal from "./components/ReviewModal";
import { useApplications } from "../../../context/Applications";

const mstp = ({ admin }) => ({ admin });

function Users({
  admin: { users, loading },
  getUsers,
  updateConfirmation,
  impersonateUser
}) {
  const { applications } = useApplications();
  const { t } = useTranslation();
  const goTo = useNavigate();
  const [mergeIsVisible, setMergeIsVisible] = useState(false);
  const { getCountry, countries } = useCountry();
  const [Users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userToReview, setUserToReview] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [mergeSelected, setMergeSelected] = useState([]);
  const {
    options,
    setOptions,
    setPerPage,
    setSearch,
    setActiveFilters,
    setActiveTab,
    activeTab,
    perPageObject,
    searchObject,
    activeFiltersObject,
    visibleTabs,
    fetchRequests,
    requests,
    usersFetched,
    setUsersFetched,
    requestsFetched,
    totalsObject,
    setTotal,
    fetchUsers,
    setPage,
    blocked,
    fetchBlocked,
    blockedFetched,
  } = useAdminUsers({ setLoading, getUsers });

  const onDisable = useCallback(async (v, isCompany = false) => {
    setLoading(true);

    try {
      if (isCompany) {
        await AdminService.disableCompany(v.id);
      } else {
        await AuthenticationService.removeSubUser(v.companyId, v.id);
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (users?.options) {
      setOptions(TABS.ACTIVE, users.options);
      setTotal(TABS.ACTIVE, users?.meta?.total || 0);
    }
  }, [users]);

  const columnConfig = useMemo(() => ({
    setSelectedUser, impersonateUser, getCountry, onDisable, setUserToReview,
  }), [getCountry, onDisable]);

  useEffect(() => {
    if (users && users.data) {
      setUsers(users.data.map(mapOrganisation));
    }
  }, [users]);

  const handleCancel = () => setSelectedUser(null);

  const sectionProps = {
    loading: loading || isLoading, setSearch, columnConfig, setActiveFilters, setPerPage, setLoading,
    setMergeSelected, mergeSelected, fetchUsers, fetchRequests, requests, blocked, setUsersFetched,
    requestsFetched, fetchBlocked,
  };

  const itemsToMerge = useMemo(() => {
    return mergeSelected.map((s) => Users.find((u) => u.key === s));
  }, [Users, mergeSelected]);

  const renderBody = () => {
    return (
      <>
        {visibleTabs[TABS.ACTIVE] ? (
          <div style={{ display: activeTab === TABS.ACTIVE ? undefined : 'none' }}>
            <Active
              applications={applications}
              usersFetched={usersFetched}
              total={totalsObject[TABS.ACTIVE]}
              setPage={(val) => setPage(TABS.ACTIVE, val)}
              countries={countries}
              setTotal={(val) => setTotal(TABS.ACTIVE, val)}
              options={options[TABS.ACTIVE]}
              setOptions={(val) => setOptions(TABS.ACTIVE, val)}
              dataSource={Users}
              perPage={perPageObject[TABS.ACTIVE]}
              search={searchObject[TABS.ACTIVE]}
              activeFilters={activeFiltersObject[TABS.ACTIVE]}
              {...sectionProps}
            />
          </div>
        ) : null}

        <div style={{ display: activeTab === TABS.REQUESTS ? undefined : 'none' }}>
          <Requests
            applications={applications}
            total={totalsObject[TABS.REQUESTS]}
            countries={countries}
            setTotal={(val) => setTotal(TABS.REQUESTS, val)}
            options={options[TABS.REQUESTS]}
            setPage={(val) => setPage(TABS.REQUESTS, val)}
            setOptions={(val) => setOptions(TABS.REQUESTS, val)}
            search={searchObject[TABS.REQUESTS]}
            perPage={perPageObject[TABS.REQUESTS]}
            activeFilters={activeFiltersObject[TABS.REQUESTS]}
            {...sectionProps}
          />
        </div>

        {visibleTabs[TABS.BLOCKED] ? (
          <div style={{ display: activeTab === TABS.BLOCKED ? undefined : 'none' }}>
            <Blocked
              applications={applications}
              countries={countries}
              total={totalsObject[TABS.BLOCKED]}
              setPage={(val) => setPage(TABS.BLOCKED, val)}
              setTotal={(val) => setTotal(TABS.BLOCKED, val)}
              options={options[TABS.BLOCKED]}
              setOptions={(val) => setOptions(TABS.BLOCKED, val)}
              search={searchObject[TABS.BLOCKED]}
              blockedFetched={blockedFetched}
              perPage={perPageObject[TABS.BLOCKED]}
              activeFilters={activeFiltersObject[TABS.BLOCKED]}
              {...sectionProps}
              dataSource={blocked}
            />
          </div>
        ) : null}
      </>
    );
  };

  const onUsersSubmit = (values = []) => {
    if (activeTab === TABS.BLOCKED && !values.filter((v) => v.access).length) {
      return;
    }

    setLoading(true);
    const isBlocked = activeTab === TABS.BLOCKED || !values.filter((v) => v.access).length;

    updateConfirmation(selectedUser.id, { values, isBlocked }, () => {
      if (activeTab === TABS.REQUESTS) {
        fetchRequests({});
      } else if (activeTab === TABS.BLOCKED) {
        fetchBlocked({});
        fetchUsers({});
      } else {
        fetchUsers({});
      }
      setLoading(false);
      handleCancel();
    });
  }

  const actionButtons = activeTab !== TABS.ACTIVE ? [] : mergeSelected.length > 1 ? [{
    label: t('Merge'),
    onClick: () => setMergeIsVisible(true),
  }] : [{
    label: t('Merge'),
    onClick: () => setMergeIsVisible(true),
    disabled: true,
    tooltip: t('Select two or more users'),
  }]
  const breadCrumbs = useMemo(() =>
    renderBreadCrumbs({ t, view: 'users', goTo, mod: 'admin' }), [t, goTo]);

  return (
    <Styles className="semibold form-input-output">
      <SubjectTableLayout
        header={(
          <>
            <Header
              breadcrumbs={breadCrumbs}
              title={t('Users')}
              actionButtons={actionButtons}
            />
            <TabsHeader
              value={activeTab}
              onChange={(v) => setActiveTab(v)}
              tabs={tabs.map((tab) => ({
                value: tab.key,
                label: (
                  <div className="tab-cont">
                    <div className="flex flex-column justify-content-center">
                      {t(tab.label)}
                    </div>
                    <div className="flex flex-column justify-content-center">
                      {!!(tab.showRequests && requestsFetched) && (
                        <div className="bubble">
                          <div className="flex flex-column justify-content-center">
                            {totalsObject[TABS.REQUESTS]}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ),
              }))}
            />
          </>
        )}
      >

        {renderBody()}

        {(selectedUser) ? (
          <PermissionsModal
            selectedUser={selectedUser}
            handleCancel={handleCancel}
            t={t}
            isLoading={isLoading}
            onUsersSubmit={onUsersSubmit}
            selectedModule={selectedModule}
            setSelectedModule={setSelectedModule}
          />
        ) : null}

        {(userToReview) ? (
          <ReviewModal
            selectedUser={userToReview}
            handleCancel={() => setUserToReview(null)}
            t={t}
            isLoading={isLoading}
            onUsersSubmit={() => {
              setUserToReview(null)
              fetchRequests({});
            }}
          />
        ) : null}

        <Modal
          title={(
            <ModalHeader
              title={`${t('Merging')} ${itemsToMerge.length} ${t('subjects')}`}
            />
          )}
          open={mergeIsVisible}
          footer={null}
          width={1300}
          closable={false}
          destroyOnClose
        >
          <Merger
            options={options[TABS.ACTIVE]}
            itemsToMerge={itemsToMerge}
            setItemsToMerge={(v) => {
              setMergeIsVisible(false);
              fetchUsers({});
              if (Array.isArray(v)) {
                setMergeSelected(v);
              } else {
                setMergeSelected([]);
              }
            }}
            mergerColumns={[]}
            close={() => setMergeIsVisible(false)}
            t={t}
            {...sectionProps}
          />
        </Modal>
      </SubjectTableLayout>
    </Styles>
  );
}

export default connect(mstp, actions)(Users);
